import script from "./LabelScanner.vue?vue&type=script&setup=true&lang=js"
export * from "./LabelScanner.vue?vue&type=script&setup=true&lang=js"

import "./LabelScanner.vue?vue&type=style&index=0&id=643a5d2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-643a5d2e"]])

export default __exports__